import {
  Routes,
  Route,
  useParams,
  Link,
  useNavigate,
  Navigate,
} from "react-router-dom";
import { useState, useEffect } from "react";
import { useAuth } from "../../components/useAuth";
import { useForm } from "react-hook-form";
import "./Announcement.css"; // 共通デザイン

const getCategoryLabel = (val) => {
  if (val === 1 || val === "1") return "医療機関";
  if (val === 2 || val === "2") return "運営";
  return "";
};

const getSuFlagLabel = (val) => {
  if (val === 1 || val === "1") return "全権管理者";
  return "一般管理者";
};

const ItemsRow = (props) => {
  const categoryLabel = getCategoryLabel(props.category);
  const suFlagLabel = getSuFlagLabel(props.su_flag);

  return (
    <div className="ann-row ann-row-body">
      <div className="ann-col ann-col-admin-name">{props.name}</div>

      <div className="ann-col ann-col-admin-email" title={props.email}>
        {props.email}
      </div>

      <div className="ann-col ann-col-admin-category">{categoryLabel}</div>

      <div className="ann-col ann-col-admin-role">{suFlagLabel}</div>

      <div className="ann-col ann-col-actions">
        <Link
          to={"/adminusers/" + props.id}
          data-id={props.id}
          className="btn btn-ghost btn-sm"
          style={{ marginRight: "0.2rem" }}
        >
          編集
        </Link>

        <Link
          to={"/adminusers/delete/" + props.id}
          data-id={props.id}
          className="btn btn-danger btn-sm"
        >
          削除
        </Link>
      </div>
    </div>
  );
};

const api_url = "https://api.ope-note.jp/admin/admin_users.php";

const AdminUsersHome = () => {
  const [itemList, setItemList] = useState([]);
  const [page, setCurrentPage] = useState(1);
  const { token } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(api_url, {
          method: "POST",
          mode: "cors",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            page: page,
            mode: "list",
            token: token,
          }),
        });
        if (!response.ok) {
          if (response.status === 404 || response.status === 401) {
            //console.log('navigete to /')
            navigate("/login");
          }
          throw new Error(response.status);
        }
        // console.log(response.data);
        const data = await response.json();

        setItemList(data.data || []);
      } catch (err) {
        console.log(err);
        setItemList([]);
      }
    };
    fetchData();
  }, [page, token, navigate]);

  const tablelist = itemList.map((item) => (
    <ItemsRow
      key={item.id}
      id={item.id}
      name={item.name}
      email={item.email}
      category={item.category}
      su_flag={item.su_flag}
    />
  ));

  return (
    <>
      <div className="announcement-header">
        <h4 className="announcement-title">管理者ユーザー一覧</h4>

        <Link to="0" className="btn btn-primary">
          ＋ 新規作成
        </Link>
      </div>

      <div className="announcement-card">
        <div className="ann-row ann-row-header">
          <div className="ann-col ann-col-admin-name">氏名</div>

          <div className="ann-col ann-col-admin-email">メールアドレス</div>

          <div className="ann-col ann-col-admin-category">区分</div>

          <div className="ann-col ann-col-admin-role">権限</div>

          <div className="ann-col ann-col-actions">操作</div>
        </div>

        {tablelist.length > 0 ? (
          <div className="ann-table-body">{tablelist}</div>
        ) : (
          <div className="ann-empty">
            登録されている管理者ユーザーはいません。
          </div>
        )}
      </div>
    </>
  );
};

const AdminUsersForm = () => {
  const { id } = useParams();
  const { token, category: authCategory } = useAuth();
  const [error, setError] = useState("");
  const navigate = useNavigate();
  //const { category } = useAuth();
  console.log(authCategory);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const isEdit = !!id && id !== "0";

  const fetchData = async (edit_id) => {
    try {
      const response = await fetch(api_url, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mode: "row", token: token, id: edit_id }),
      });
      if (!response.ok) {
        throw new Error(response.status);
      }
      const data = await response.json();
      if (data.result) {
        setValue("name", data.data.name);
        setValue("email", data.data.email);

        // ★ ログインユーザーが category=1 の場合は強制的に 1 をセット
        if (authCategory === 1 || authCategory === "1") {
          setValue("category", "1");
        } else {
          setValue("category", String(data.data.category));
        }

        setValue("su_flag", String(data.data.su_flag));
      } else {
        navigate("/adminusers");
      }
    } catch (err) {
      if(err.message === '401' || err.message === '404'){
        navigate('/login');
      }
      console.log(err);
    }
  };

  useEffect(() => {
    if (isEdit) {
      fetchData(id);
    } else {
      // 新規作成時、ログインユーザーが category=1 なら hidden 用に事前セット
      if (authCategory === 1 || authCategory === "1") {
        setValue("category", "1");
      }
    }
  }, [id]);

  const onSubmit = async (data) => {
    // ★ ログインユーザーが category=1 の場合は、強制的に "1" を送る
    const categoryToSend =
      authCategory === 1 || authCategory === "1" ? "1" : data.category;
    const post_data = {
      id: data.id,
      name: data.name,
      email: data.email,
      category: data.category,
      su_flag: data.su_flag,
      token: token,
      mode: data.id ? "edit" : "add",
    };

    // パスワードは未入力なら送らない（編集時に何もしない）
    if (data.password) {
      post_data.password = data.password;
    } else if (!data.id) {
      // 新規作成時は必須
      setError("パスワードを入力してください");
      return;
    }

    try {
      const response = await fetch(api_url, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(post_data),
      });

      if (!response.ok) {
        throw new Error(response.status);
      }
      const resData = await response.json();
      if (resData.result) {
        navigate("/adminusers");
      } else {
        setError(resData.error || "失敗しました");
      }
    } catch (err) {
      if(err.message === '401' || err.message === '404'){
        navigate('/login');
      }
      console.log(err);
      setError("通信エラーです");
    }
  };

  return (
    <div className="announcement-form-wrapper">
      <div className="announcement-form-header">
        <Link to="../../adminusers" className="btn btn-ghost">
          ＜ 一覧へ戻る
        </Link>

        <h4 className="announcement-title">
          {isEdit ? "管理者ユーザーの編集" : "管理者ユーザーの新規登録"}
        </h4>
      </div>

      <form className="frm ann-form-card" onSubmit={handleSubmit(onSubmit)}>
        {error && <div className="frm-error">{error}</div>}

        <div className="frm-row">
          <label>氏名</label>

          <input
            type="text"
            className="frm-input"
            {...register("name", {
              required: true,
            })}
          />

          {errors.name && (
            <div className="frm-error-text">入力が必須の項目です</div>
          )}
        </div>

        <div className="frm-row">
          <label>メールアドレス</label>

          <input
            type="email"
            className="frm-input"
            {...register("email", {
              required: true,
            })}
          />

          {errors.email && (
            <div className="frm-error-text">入力が必須の項目です</div>
          )}
        </div>

        <div className="frm-row">
          <label>
            パスワード
            {isEdit && (
              <span
                style={{
                  marginLeft: "0.5rem",
                  fontSize: "0.8rem",
                  color: "#6b7280",
                }}
              >
                （変更する場合のみ入力）
              </span>
            )}
          </label>

          <input
            type="password"
            className="frm-input"
            {...register("password")}
          />
        </div>

        <div className="frm-row">
          <label>区分</label>

          {authCategory === 1 || authCategory === "1" ? (
            <>
              {/* ★ hidden で 1 を送信 */}
              <input
                type="hidden"
                {...register("category", { required: true })}
                value="1"
              />
              <div className="frm-static">医療機関</div>
            </>
          ) : (
            <>
              <select
                className="frm-select"
                {...register("category", { required: true })}
              >
                <option value="">選択してください</option>
                <option value="1">医療機関</option>
                <option value="2">運営</option>
              </select>
              {errors.category && (
                <div className="frm-error-text">入力が必須の項目です</div>
              )}
            </>
          )}
        </div>

        <div className="frm-row">
          <label>権限</label>

          <div className="ann-radio-group">
            <label className="ann-radio">
              <input
                type="radio"
                value="0"
                {...register("su_flag", { required: true })}
              />
              一般管理者
            </label>

            <label className="ann-radio">
              <input
                type="radio"
                value="1"
                {...register("su_flag", { required: true })}
              />
              全権管理者
            </label>
          </div>

          {errors.su_flag && (
            <div className="frm-error-text">権限を選択してください</div>
          )}
        </div>

        <input type="hidden" {...register("id")} defaultValue={id} />

        <div className="frm-footer">
          <button type="submit" className="btn btn-primary">
            保存する
          </button>
        </div>
      </form>
    </div>
  );
};

const AdminUsersDeleteConfirm = () => {
  const { id } = useParams();
  const { token } = useAuth();
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [viewData, setViewData] = useState([]);

  const { register, handleSubmit } = useForm();

  const fetchData = async (edit_id) => {
    try {
      const response = await fetch(api_url, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mode: "detail", token: token, id: edit_id }),
      });
      if (!response.ok) {
        throw new Error(response.status);
      }
      const data = await response.json();
      if (data.result) {
        setViewData(data.data);
      } else {
        navigate("/adminusers");
      }
    } catch (err) {
      if(err.message === '401' || err.message === '404'){
        navigate('/login');
      }
      console.log(err);
    }
  };

  useEffect(() => {
    if (id > 0) {
      fetchData(id);
    } else {
      navigate("/adminusers");
    }
  }, [id]);

  const onSubmit = async (data) => {
    const post_data = {
      id: data.id,
      token: token,
      mode: "delete",
    };
    try {
      const response = await fetch(api_url, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(post_data),
      });

      if (!response.ok) {
        throw new Error(response.status);
      }
      const resData = await response.json();

      if (resData.result) {
        navigate("/adminusers");
      } else {
        setError(resData.error);
      }
      return true;
    } catch (err) {
      if(err.message === '401' || err.message === '404'){
        navigate('/login');
      }
      console.log(err);
      setError("通信エラーです");
    }
  };

  const categoryLabel = getCategoryLabel(viewData.category);
  const suFlagLabel = getSuFlagLabel(viewData.su_flag);

  return (
    <div className="announcement-form-wrapper">
      <div className="announcement-form-header">
        <Link to="../../adminusers" className="btn btn-ghost">
          ＜ 一覧へ戻る
        </Link>

        <h4 className="announcement-title">管理者ユーザー削除確認</h4>
      </div>

      <form className="frm ann-form-card" onSubmit={handleSubmit(onSubmit)}>
        {error && <div className="frm-error">{error}</div>}

        <div className="frm-row">
          <div className="delete-warning">
            この管理者ユーザーを削除しますか？（元に戻せません）
          </div>
        </div>

        <div className="frm-row">
          <label>氏名</label>

          <div className="frm-static">{viewData.name}</div>
        </div>

        <div className="frm-row">
          <label>メールアドレス</label>

          <div className="frm-static">{viewData.email}</div>
        </div>

        <div className="frm-row">
          <label>区分</label>

          <div className="frm-static">{categoryLabel}</div>
        </div>

        <div className="frm-row">
          <label>権限</label>

          <div className="frm-static">{suFlagLabel}</div>
        </div>

        <input type="hidden" {...register("id")} defaultValue={id} />

        <div className="frm-footer frm-footer-between">
          <button
            type="button"
            className="btn btn-ghost"
            onClick={() => navigate("/adminusers")}
          >
            キャンセル
          </button>

          <button type="submit" className="btn btn-danger">
            削除する
          </button>
        </div>
      </form>
    </div>
  );
};

const AdminUsers = () => {
  const { su_flag } = useAuth(); // ★ useAuth から su_flag を取得（なければ追加してください）
  console.log(su_flag);
  // su_flag が 0（文字列 "0" 含む）ならトップへ強制リダイレクト
  if (su_flag === 0 || su_flag === "0") {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="announcement-page">
      <div className="sub_title">管理者ユーザー</div>

      <div className="announcement-inner">
        <Routes>
          <Route path="/" element={<AdminUsersHome />} />
          <Route path=":id" element={<AdminUsersForm />} />
          <Route path="/delete/:id" element={<AdminUsersDeleteConfirm />} />
        </Routes>
      </div>
    </div>
  );
};

export default AdminUsers;
